import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomerInfoLoadIfNormalUserGuard } from 'app/core/guards/customer-info-load-if-normal-user.guard';
import { DependencyTreeGuard } from 'app/core/guards/dependency-tree.guard';
import { GetDefinitionsGuard } from 'app/core/store/definitions/definitions.resolve';
import { AuthorizationGuard } from 'app/core/store/session/authorization/authorization.resolve';
import { GetEmailActorsGuard } from '../../core/store/email-actors/email-actors.resolve';
import { ContactPageContainer } from './contact/contact-page-container/contact-page.container';
import { EmailActorsPageContainer } from './email-actors/email-actors-page-container/email-actors-page.container';
import { FAQPageContainer } from './faq/faq-page-container/faq-page.container';

const routes: Routes = [
  {
    path: 'email-actors',
    component: EmailActorsPageContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [GetEmailActorsGuard, GetDefinitionsGuard, CustomerInfoLoadIfNormalUserGuard, AuthorizationGuard],
      authorization: 'useEmailActors',
    },
  },
  {
    path: 'faq',
    component: FAQPageContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [GetDefinitionsGuard],
    },
  },
  {
    path: 'contact',
    component: ContactPageContainer,
    canActivate: [],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ServiceRoutingModule {}
